import { render } from "./headline.vue?vue&type=template&id=8d48dbe0&scoped=true"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"

import "./headline.vue?vue&type=style&index=0&id=8d48dbe0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d48dbe0"]])

export default __exports__